import { castArray } from "lib/castArray"

export function haveReactChildren<T>(el: T): el is Exclude<T, never[] | undefined> {
  if (castArray(el)[0]) {
    return true
  }
  return false
}
